
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/activity/tenyears/combine",
      function () {
        return require("private-next-pages/activity/tenyears/combine/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/activity/tenyears/combine"])
      });
    }
  